const styles = {
  root: {
    background: '#FAFAFF',
    minHeight: '100vh',
    fontSize: 16,
    position: 'relative',
    '& .action': {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
    },
  },
};

export default styles;
